<template>
  <a-row class="section">
    <section-strategy-details :data-source="props.dataSource" class="section__details" />
    <!-- <div class="filter--details" v-if="strategyOrigin === 1">
      <h4>Filtros de contactos asignados:</h4>
      <h5>Usuarios asignados:</h5>
      <ul>
        <li>karina.prado@securitec.pe</li>
      </ul>
      <h5>Fecha de última gestión de los contactos:</h5>
      <ul>
        <li>Desde: 23/07/2023</li>
        <li>Hasta: 24/07/2023</li>
      </ul>
    </div> -->
    <div class="section__preview">
      <iframe
        :srcdoc="templateEmail"
        class="iframe-email"
        height="480px"
        width="800px"
        ref="iframe"
        title="preview-email-details"
        @load="scaleIframeContent"
      ></iframe>
    </div>
  </a-row>
</template>
<script lang="ts" setup>
import { computed, ref } from "vue";
import SectionStrategyDetails from "@/app/strategies/components/sections/SectionStrategyDetails.vue";
import { DataSourceStrategy } from "@/@types/strategies/modalStrategy";
const props = defineProps<{
  dataSource: DataSourceStrategy;
  strategyOrigin: number;
}>();

const templateEmail = computed(() => {
  return props.dataSource.message_text;
});

const iframe = ref();

const scaleIframeContent = () => {
  console.log("iframe.value.contentWindow", iframe.value.contentWindow);
  if (props.dataSource.template_email) {
    const scale = 0.7; // Escala el contenido al 70% de su tamaño original
    iframe.value.contentWindow.document.body.style.zoom = scale;

    const iframeDoc = iframe.value.contentDocument || iframe.value.contentWindow.document;
    const style = iframeDoc.createElement("style");
    style.textContent = `
      ::-webkit-scrollbar {
        width: 10px;
        margin-right: 10px;
      }
      ::-webkit-scrollbar-thumb {
        background-color: #D9D9D9;
        border-radius: 5px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background-color: #D9D9D9;
      }
    `;
    iframeDoc.head.appendChild(style);
  }
};
</script>
<!-- <style lang="sass" scoped>
.filter
  &--details
    background: #F2F5F7
    padding: 10px
    border-radius: 4px
</style> -->
<style lang="sass">
.section
  &__details
    margin-right: 40px
    width: 180px
  &__preview
    width: 224px

.iframe-email
  border-radius: 8px
  border: 1px solid #00000026
</style>
